import React, { useCallback, useState } from 'react';
import _ from 'lodash';
import { Button, TextArea } from '@scale/scaleui';
import { lookupUserIdsOrEmails } from '../api';
import { IUserDetail } from 'react-scale/components/WebinarSessions/types';

interface UserIdsOrEmailsTextInputProps {
  setUsers: React.Dispatch<React.SetStateAction<IUserDetail[]>>;
  placeholder?: string;
  callbackFn?: (users: IUserDetail[]) => void;
}

export const UserIdsOrEmailsTextInput: React.FC<UserIdsOrEmailsTextInputProps> = ({
  setUsers,
  placeholder,
  callbackFn,
}) => {
  const [rawUserIdsOrEmailsText, setRawUserIdsOrEmailsText] = useState<string>(''); // Can be userIds or emails
  const [parsingRawUserIdsOrEmailsText, setParsingRawUserIdsOrEmailsText] =
    useState<boolean>(false);

  const parseRawUserIdsOrEmailsText = useCallback(() => {
    const potentialIdsOrEmails = rawUserIdsOrEmailsText.split(/[ :;?!~,`"&|()<>{}[\]\r\n/\\]+/);
    (async () => {
      setParsingRawUserIdsOrEmailsText(true);
      const users = await lookupUserIdsOrEmails(potentialIdsOrEmails);
      setUsers(u => _.uniqBy([...u, ...users], 'id'));
      if (callbackFn) callbackFn(users);
      setRawUserIdsOrEmailsText('');
      setParsingRawUserIdsOrEmailsText(false);
    })();
  }, [rawUserIdsOrEmailsText, setUsers, callbackFn]);

  return (
    <div className="flex gap-2 items-center">
      <TextArea
        placeholder={
          placeholder ??
          'Paste in user IDs or emails (with the +outlier suffix), separated by any delimiter'
        }
        value={rawUserIdsOrEmailsText}
        onChange={e => setRawUserIdsOrEmailsText(e.target.value)}
        className="w-full"
      />
      <Button onClick={parseRawUserIdsOrEmailsText} disabled={parsingRawUserIdsOrEmailsText}>
        Add
      </Button>
    </div>
  );
};
